var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam"},[(_vm.examData)?_c('div',[_c('Exam',{staticStyle:{"text-align":"left !important"},attrs:{"enableListenTotalTimer":false,"liveData":_vm.examData}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }